import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { CuestionarioPregunta } from '../../_models/cuestionario-pregunta';
import { CuestionarioPreguntaService } from '../../_services/cuestionario-pregunta.service';
import { Cuestionario } from '../../_models/cuestionario';
import { CuestionarioPreguntaRespuesta } from '../../_models/cuestionario-pregunta-respuesta';
import { forkJoin } from 'rxjs';
import { CuestionarioPreguntaRespuestaService } from '../../_services/cuestionario-pregunta-respuesta.service';
import { ConfirmationService } from 'primeng/api';
import { CuestionarioService } from '../../_services/cuestionario.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { RetornoFuncionalidades } from '../../_models/retorno-funcionalidades';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';

@Component( {
  selector: 'app-cuestionarios-pregunta',
  templateUrl: 'cuestionarios-pregunta.component.html'
} )

export class CuestionariosPreguntaComponent implements OnInit {

  _cuestionario: Cuestionario;
  @Output() camOrdenado: EventEmitter<boolean> = new EventEmitter();
  columnas: any[];
  carInformacionInicial = true;
  preguntas: CuestionarioPregunta[] = [];
  preRespuestas: CuestionarioPreguntaRespuesta[] = [];
  seccion = 'L';
  menu: Funcionalidad = new Funcionalidad();
  cuePreguntaSeleccionada: CuestionarioPregunta;
  mosPregunta = false;
  colRespuestas: any[] = [];
  carTabla = false;

  @Input()
  set cuestionario( cuestionario: Cuestionario ) {
    if ( this._cuestionario && this._cuestionario.indicadorAzar !== cuestionario.indicadorAzar && cuestionario.indicadorAzar ) {
      this.carInformacionInicial = true;
      this.seccion = 'L';
      this.preRespuestas.map( ( s: CuestionarioPreguntaRespuesta ) => {
        if ( s.indicadorHabilitado && (s.idPreguntaDepende !== '' && s.idPreguntaDepende !== null && s.idPreguntaDepende !== undefined) ) {
          s.idPreguntaDepende = null;
          s.preguntaDepende = null;
        }
      } );
      this.cargarPreguntasRespuestas();
      this.carInformacionInicial = false;
    }
    this._cuestionario = cuestionario;
  }

  get cuestionario(): Cuestionario {
    return this._cuestionario;
  }


  constructor( private navServicio: NavService,
               private cuePreguntaService: CuestionarioPreguntaService,
               private cuePreguntaRespuestaServicio: CuestionarioPreguntaRespuestaService,
               private cueServicio: CuestionarioService,
               private router: Router,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/preguntas' );
    if ( mn ) {
      this.menu = mn;
    }
    this.columnas = [
      { field: 'orden', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_ORDEN' ), sort: false },
      { field: 'pregunta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_PREGUNTA' ), sort: false },
      { field: 'tipoPregunta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_TIPO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false },
    ];

    this.colRespuestas = [
      { field: 'respuesta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_RESPUESTA' ), sort: false },
      { field: 'preguntaDepende', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_PREGUNTADEPENDE' ), sort: false },
      { field: 'indicadorCorrecta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_CORRECTO' ), sort: false }
    ];

    forkJoin( this.cuePreguntaService.listadoPorCuestionario( this.cuestionario.idCuestionario ), this.cuePreguntaRespuestaServicio.listadoPorCuestionario( this.cuestionario.idCuestionario ) ).subscribe( ( [ cuePreguntas, cuePreguntasRespuestas ] ) => {
      this.preguntas = cuePreguntas;
      this.preRespuestas = cuePreguntasRespuestas.filter( x => x.indicadorHabilitado );
      this.cargarPreguntasRespuestas();
      this.ordenarPreguntas();
      this.carInformacionInicial = false;
    } );
  }

  cargarPreguntasRespuestas() {
    this.preguntas.map( ( s: CuestionarioPregunta ) => {
      s.respuestas = this.preRespuestas.filter( x => x.idCuestionarioPregunta === s.idCuestionarioPregunta );
    } );
  }

  ver( pregunta: CuestionarioPregunta ) {
    this.cuePreguntaSeleccionada = pregunta;
    this.mosPregunta = true;
  }

  configurar( pregunta: CuestionarioPregunta ) {
    this.cuePreguntaSeleccionada = pregunta;
    this.seccion = 'R';
  }

  inhabilitar( pregunta: CuestionarioPregunta ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'pregunta',
      accept: () => {
        this.carTabla = true;
        pregunta.indicadorHabilitado = false;
        this.cuePreguntaService.actualizar( pregunta ).subscribe( actRegistro => {
          const indice = this.preguntas.findIndex( x => x.idCuestionarioPregunta === pregunta.idCuestionarioPregunta );
          if ( indice >= 0 ) {
            this.preguntas[ indice ] = pregunta;
          }
          this.navServicio.setMesage( 2 );
          this.carTabla = false;
        } );
      },
      reject: () => {
      }
    } );
  }

  nuevaPregunta() {
    let retFuncionalidad: RetornoFuncionalidades = {
      identificador: 'CUEPRE',
      proceso: this.navServicio.buscarMensaje( 'CUESTIONARIO.LBL_CUESTIONARIOS' ),
      ruta: 'apl/cuestionarios/actualizar/' + this.cuestionario.idCuestionario,
      constante: null,
      idProceso: this.cuestionario.idCuestionario,
      otros: null
    };
    this.navServicio.setTab( 'PREGUNTAS' );
    this.navServicio.setRetornoFuncionalidad( retFuncionalidad );
    this.router.navigate( [ 'apl/preguntas/agregar' ] );
  }

  importarPregunta() {
    this.seccion = 'BP';
  }

  private ordenarPreguntas() {
    this.preguntas.sort( function( a, b ) {
      if ( a.orden < b.orden ) {
        return -1;
      } else {
        return 1;
      }
    } );
  }

  confirmarPreguntasDependientes( resDependientes: CuestionarioPreguntaRespuesta[], miIndice: number, subir: boolean ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.MSG_CAMBIARADEPENDENCIA' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'pregunta',
      accept: () => {
        resDependientes.map( ( s: CuestionarioPreguntaRespuesta ) => {
          s.idPreguntaDepende = null;
          const a = this.preRespuestas.findIndex( x => x.idCuestionarioPreguntaRespuesta === s.idCuestionarioPreguntaRespuesta );
          if ( a >= 0 ) {
            this.preRespuestas[ a ].idPreguntaDepende = null;
            this.preRespuestas[ a ].preguntaDepende = null;
          }
        } );
        this.cuePreguntaRespuestaServicio.bulk( resDependientes ).subscribe( bulk => {
          this.cargarPreguntasRespuestas();
          this.cambiarOrden( miIndice, subir );
        } );
      },
      reject: () => {
        this.carTabla = false;
      }
    } );
  }

  bajar( item: CuestionarioPregunta ) {
    let miIndice = this.preguntas.indexOf( item );
    if ( miIndice < this.preguntas.length - 1 ) {
      this.carTabla = true;
      if ( this.cuestionario.indicadorOrdenado ) {
        const preSiguiente = this.preguntas[ miIndice + 1 ];
        const resDependePregunta = item.respuestas.filter( x => (x.idPreguntaDepende !== '' && x.idPreguntaDepende !== null && x.idPreguntaDepende !== undefined) && x.idPreguntaDepende === preSiguiente.idCuestionarioPregunta );
        if ( resDependePregunta.length > 0 ) {
          this.confirmarPreguntasDependientes( resDependePregunta, miIndice, false );
        } else {
          this.cambiarOrden( miIndice, false );
        }
      } else {
        this.cambiarOrden( miIndice, false );
      }
    }
  }

  subir( item: CuestionarioPregunta ) {
    let miIndice = this.preguntas.indexOf( item );
    if ( miIndice > 0 ) {
      this.carTabla = true;
      if ( this.cuestionario.indicadorOrdenado ) {
        const preAnterior = this.preguntas[ miIndice - 1 ];
        const resDependePregunta = preAnterior.respuestas.filter( x => (x.idPreguntaDepende !== '' && x.idPreguntaDepende !== null && x.idPreguntaDepende !== undefined) && x.idPreguntaDepende === item.idCuestionarioPregunta );
        if ( resDependePregunta.length > 0 ) {
          this.confirmarPreguntasDependientes( resDependePregunta, miIndice, true );
        } else {
          this.cambiarOrden( miIndice, true );
        }
      } else {
        this.cambiarOrden( miIndice, true );
      }
    }
  }

  cambiarOrden( miIndice: number, subir: boolean ) {
    let nueOrden = this.preguntas[ miIndice ].orden;
    if ( subir ) {
      this.preguntas[ miIndice ].orden = this.preguntas[ miIndice - 1 ].orden;
      this.cuePreguntaService.actualizar( this.preguntas[ miIndice ] ).subscribe( res => {
        this.preguntas[ miIndice - 1 ].orden = nueOrden;
        this.cuePreguntaService.actualizar( this.preguntas[ miIndice - 1 ] ).subscribe( res => {
          this.ordenarPreguntas();
          this.carTabla = false;
        } );
      } );
    } else {
      this.preguntas[ miIndice ].orden = this.preguntas[ miIndice + 1 ].orden;
      this.cuePreguntaService.actualizar( this.preguntas[ miIndice ] ).subscribe( res => {
        this.preguntas[ miIndice + 1 ].orden = nueOrden;
        this.cuePreguntaService.actualizar( this.preguntas[ miIndice + 1 ] ).subscribe( res => {
          this.ordenarPreguntas();
          this.carTabla = false;
        } );
      } );
    }

  }

  finalizarOrdenamiento() {
    this.carInformacionInicial = true;
    this.cuestionario.indicadorOrdenado = true;
    this.cueServicio.actualizar( this.cuestionario ).subscribe( cue => {
      this.camOrdenado.emit( true );
      this.carInformacionInicial = false;
    } );
  }

  cambioAcciones( tipo: string ) {
    switch ( tipo ) {
      case 'NL': {
        this.seccion = 'L';
        break;
      }
      case 'L': {
        this.carInformacionInicial = true;
        this.seccion = 'L';
        this.cuePreguntaService.listadoPorCuestionario( this.cuestionario.idCuestionario ).subscribe( preguntas => {
          this.preguntas = preguntas;
          this.cargarPreguntasRespuestas();
          this.ordenarPreguntas();
          this.carInformacionInicial = false;
        } );
        break;
      }
      default:
    }

  }

  cerrar() {
    this.mosPregunta = false;
    this.cuePreguntaSeleccionada = null;
  }


}
